var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.5H27C27.2761 7.5 27.5 7.72386 27.5 8V8.36051L16.804 17.3452C16.3391 17.7357 15.6609 17.7357 15.196 17.3452L4.5 8.36051V8C4.5 7.72386 4.72386 7.5 5 7.5ZM4.5 10.3195V24C4.5 24.2761 4.72386 24.5 5 24.5H27C27.2761 24.5 27.5 24.2761 27.5 24V10.3195L17.7688 18.4937C16.7461 19.3528 15.2539 19.3528 14.2312 18.4937L4.5 10.3195ZM3 8C3 6.89543 3.89543 6 5 6H27C28.1046 6 29 6.89543 29 8V24C29 25.1046 28.1046 26 27 26H5C3.89543 26 3 25.1046 3 24V8Z",
    fill: "#0A7CC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f46be8b4834d9c5a1a2966fbb0f4f4c2.svg";
export { ForwardRef as ReactComponent };